import {useState} from 'react'
import Collapse from '@mui/material/Collapse'
import Box from '@mui/material/Box'
import {SelectButton} from '../1elements'
import CollapseArrowIcon from '../1elements/Icons/js/CollapseArrowIcon'
import ListSubheader from '@mui/material/ListSubheader'
import Divider from '@mui/material/Divider'

const SubCollapseForCard = ({header, dataCount, children, onClick, className, divider, sx}) => {
    const [toggle, setToggle] = useState(true)

    return (
        <Box className={className} sx={[{ width: '100%' }, ...(sx ? (Array.isArray(sx) ? sx : [sx]) : [])]}>
            <ListSubheader sx={{ padding: 0 }}>
                <CollapseArrowIcon toggle={toggle}
                                   setToggle={setToggle} />
                <strong>{header} ({dataCount})</strong>
            </ListSubheader>
            <Collapse in={toggle} timeout="auto" unmountOnExit>
                {children}
                {onClick && (
                    <Box sx={{ display: 'flex', margin: '20px 0 40px', width: '100%' }}>
                        <SelectButton onClick={onClick} />
                    </Box>
                )}
            </Collapse>
            {divider && <Divider variant="fullWidth" />}
        </Box>
    )
}

export default SubCollapseForCard
